import { GET_PARAMS } from "./paramHelper";
export const RECEIVE_BRANDS = "RECEIVE_BRANDS";
export const METADATA_ERROR = "METADATA_ERROR";

export const searchByType = async (type, query, country) => {
  try {
    const response = await fetch(
      `/api/metadata?type=${type}&name=${encodeURIComponent(
        query
      )}&country=${country}`,
      GET_PARAMS()
    );

    if (!response.ok) {
      const json = await response.json();
      throw new Error(json.error);
    }

    let { results } = await response.json();
    results = results.map(result => ({
      value: result[`${type}_id`],
      label: result.name
    }));

    return results;
  } catch (error) {
    return [];
  }
};
